<template>
  <div class="card" v-show="currentCardId == 'job-history'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>職歴を入力</h2>
        <p>会社名・役職・期間・業務内容を入力してください</p>
      </div>
      <div class="card-content card-content-list">
        <div class="edit-form-list">
          <transition-group name="fade" tag="div">
            <HistoryItemJob
              v-for="(item, index) in formatData.jobHistories"
              :key="item.uuid"
              @add-history-item="addJobHistory"
              @delete-history-item="deleteJobHistory"
              @move-history-item="moveJobHistory"
              @add-project-history-item="addProjectHistory"
              @delete-history-item-detail="deleteHistoryDetail"
              @move-history-item-detail="moveJobHistoryDetail"
              @click.native="activateHistoryItem(item.uuid)"
              :item="item"
              :length="formatData.jobHistories.length"
              :index="index"
              :id="item.uuid"
              :class="{ active: activeHistoryItem == item.uuid }"
              :minYear="basicData.birthYear"
              :createDate="formatData.createDate"
              :activeHistoryItem="activeHistoryItem"
              :descriptionPlaceholder="'会社名を入力'"
              :descriptionMaxLength="descriptionMaxLength"
              :hideCompanyDetails="true"
            />
          </transition-group>
          <div class="add-list-item">
            <el-button
              icon="el-icon-plus"
              circle
              type="success"
              @click="addJobHistory()"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import HistoryItemJob from '@/components/formats/ShokurekishoParts/HistoryItemJob.vue'
import {
  descriptionMaxLength,
  useEnglishResumeFormatData,
  useEnglishResumeHistoriesApi
} from '@/composables/format-edit/useEnglishResumeFormatData'

defineProps<{
  currentCardId?: string
  basicData: Record<string, unknown>
}>()

const formatData = useEnglishResumeFormatData()
const {
  activeHistoryItem,
  addJobHistory,
  deleteJobHistory,
  moveJobHistory,
  addProjectHistory,
  deleteHistoryDetail,
  moveJobHistoryDetail,
  activateHistoryItem
} = useEnglishResumeHistoriesApi()
</script>
